export default "__VITE_ASSET__daf36810__"